export const iconFontAwesomeMoneyChartLine = (
	<i className="fa-solid fa-chart-line"></i>
);
